import React from "react";
import classNames from "classnames";
import style from "./style.scss";

import { Icon } from "../../graphic/Icon";

export const Select = ({
    name,
    big,
    error,
    className,
    selectClassName,
    children,
    disabled,
    placeholder,
    value,
    onChange
}) => {
    // Placeholder
    const placeholderElement =
        placeholder && typeof placeholder === "object" ? (
            React.cloneElement(placeholder, {
                children: (message) => {
                    return <option value={""}>{message}</option>;
                }
            })
        ) : placeholder ? (
            <option value={""}>{placeholder}</option>
        ) : null;

    return (
        <div
            className={classNames(
                style.base,
                {
                    [style.placeholder]: value === "" || value == null,
                    [style.error]: error,
                    [style.big]: big
                },
                className
            )}
        >
            <div className={style.arrow}>
                <Icon className={style.icon} name="caret-down" />
            </div>
            <select
                name={name}
                value={value == null ? "" : value}
                onChange={(e) => onChange(e.target.value)}
                className={classNames(style.select, selectClassName)}
                disabled={disabled}
            >
                {!value || value === "" ? placeholderElement ? placeholderElement : <option value={""} /> : null}
                {children}
            </select>
        </div>
    );
};
